<template>
  <div class="edit_item">
    <div class="edit_item_top">
      <h1>{{info.name}}<span>{{info.mobile}}</span></h1>
      <div class="item_wrap">
        <span class="s_addr">性别：</span>
        <p class="s_addr_p" v-if="info.sex == '1'">男</p>
        <p class="s_addr_p" v-if="info.sex == '2'">女</p>
      </div>
      <div class="item_wrap">
        <span class="s_addr">疫苗：</span>
        <p class="s_addr_p" v-if="info.vaccines == '1'">未接种</p>
        <p class="s_addr_p" v-if="info.vaccines == '2'">已接种未完成</p>
        <p class="s_addr_p" v-if="info.vaccines == '3'">已接种完毕</p>
      </div>
      <div class="item_wrap">
        <span class="s_addr">单位：</span>
        <p class="s_addr_p">{{info.companyName}}{{info.gradeName}}{{info.className}}</p>
      </div>
      <div class="item_wrap">
        <span class="s_addr">地址：</span>
        <p class="s_addr_p">{{info.address}}</p>
      </div>
      <div class="item_wrap" v-if="info.antigen">
        <span class="s_addr">抗原：</span>
        <p class="s_addr_p" v-if="info.antigen == 1">阴性</p>
        <p class="s_addr_p" v-if="info.antigen == 2">阳性</p>
        <p class="s_addr_p" v-if="info.antigen == 3">无效</p>
      </div>
    </div>
    <div class="edit_item_bottom">
      <div class="edit_btn" @click="handleToEdit"><span>编辑</span></div>
      <div class="delete_btn" @click="handleToDelete"><span>删除</span></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: Object,
    default: () => {
      return {}
    }
  },
  methods: {
    // 点击编辑
    handleToEdit() {
      this.$emit('onEdit', this.info.id);
    },

    // 点击删除
    handleToDelete() {
      this.$emit('onDelete', this.info.id);
    }
  }
}
</script>

<style scoped>
.edit_item {
  box-sizing: border-box;
  padding-top: .4rem;
  margin-bottom: .4rem;
  box-shadow: 0px 5px 16px 0px rgba(168, 178, 188, 0.24);
}
.edit_item_top {
  box-sizing: border-box;
  padding: 0 .3rem .3rem .3rem;
  border-bottom: 1px solid #EEEEEE;
}
.edit_item_top > h1 {
  font-size: .32rem;
  color: #333;
  font-weight: 500;
}
.edit_item_top > h1 > span {
  margin-left: .3rem;
}
.item_wrap {
  display: flex;
  margin-top: .2rem;
  font-size: .28rem;
  color: #999;
}
.item_wrap > .s_addr {
  width: .85rem;
  line-height: .35rem;
}
.s_addr_p {
  flex: 1;
  line-height: .35rem;
}
.edit_item_bottom {
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: .25rem .3rem;
}
.edit_item_bottom > div {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.42rem;
  height: .59rem;
  font-size: .26rem;
  color: #333;
  border: 1px solid #B5B5B5;
  border-radius: .3rem;
}
.edit_btn {
  margin-right: .26rem;
}
.edit_item_bottom > .delete_btn {
  color:#FF4040;
  border: 1px solid #FF4040;
}
</style>